@if (alertsLoading) {
  <div class="loading-overlay">
    <loading-indicator
      loadingMessage="Please wait..."
      [includeCardClass]="false"
    ></loading-indicator>
  </div>
}

<div class="container-fluid box-shadow">
  <div class="row d-flex align-items-center">
    <div class="col-md-12 p-2 " style="border-bottom:1px solid #d3ddeb!important">
      <loda-multiSelect
        name="filters"
        placeholder="-- Select Filters --"
        [options]="availableBucketsForFiltering"
        optionValue="type"
        [(ngModel)]="selectedAlertBuckets"
        (ngModelChange)="onFilterChanged()">
      </loda-multiSelect>
    </div>
  </div>
</div>
<div class="notification-menu inset-box-shadow emails-list p-1" data-simplebar="init" [class.n-overflow]="!modal" (scroll)="onScroll($event)">
  @if (notifications?.length > 0) {
    <div class="px-2 pt-1 d-flex justify-content-end">
      <button (click)="clearAll()" class="btn btn-link text-danger" [disabled]="cleaningAll">
        @if (!cleaningAll) {
          <span>Clear All</span>
        } @else {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Clearing...
        }
      </button>
    </div>
  }
  @if (notifications) {
    <div class="p-2">
      @for (notification of notifications; track notification) {
        <div class="card email-notification-card">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-end pt-0 px-0 mx-0 mt-0">
              <h5 class="mt-0 mb-1" [innerHtml]="notification.alertText"></h5>
              <div class="">
                @if (notification.alertType === 'FailedEmailAlert') {
                  <button type="button"
                    class="btn btn-soft-primary btn-sm mr-1" (click)="resendEmail(notification)"
                    style="margin-right: 6px;">
                    Resend
                  </button>
                }
                @if (notification.alertType === 'FailedEmailAlert' || notification.alertType === 'FailedSmsAlert') {
                  <button type="button"
                    class="btn btn-link btn-sm" title="Show Details" (click)="openDetailsDialog(notification)">
                    <i class="fas fa-eye text-info font-14 icon"></i>
                  </button>
                }
                @if (notification.alertType !== 'FailedEmailAlert') {
                  <button type="button"
                    class="btn btn-link btn-sm" title="Go To" (click)="gotoDetails(notification)">
                    <i class="fas fa-share text-success font-14 icon"></i>
                  </button>
                }
                <button type="button" class="btn btn-link btn-sm" title="Remove" (click)="deleteAlert(notification, false)" [disabled]="notification['deleting'] || cleaningAll">
                  @if (!notification['deleting']) {
                    <i class="fa-solid fa-trash-alt cursor btn-danger-icon text-danger" title="Delete"></i>
                  } @else {
                    <span class="text-danger spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  }
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="d-inline">
              <p class="text-muted mb-1"><i class="far fa-user me-2 text-primary font-14 icon"></i> <strong>Borrower: </strong>{{notification.borrowerName}}</p>
            </div>
            <div class="d-inline">
              <p class="text-muted mb-1"><i class="fas fa-map-marker-alt me-2 text-success font-14 icon"></i><strong>Property Address: </strong>{{notification.propertyAddress}}</p>
            </div>
            <div class="d-inline">
              <p class="text-muted mb-1"><i class="far fa-file me-2 text-success font-14 icon"></i><strong>Current Loan Status: </strong>{{notification.applicationStatus}}</p>
            </div>
            @if (notification.alertType === 'VoicemailAlert') {
              <div class="d-inline">
                <p class="text-muted mb-1"><i class="far fa-play-circle me-2 text-success font-14 icon"></i><strong>Voicemail Link: </strong><a href="{{notification.voicemailUrl}}" target="_new">{{notification.voicemailUrl}}</a></p>
              </div>
            }
          </div>
          <div class="card-footer">
            <p class="text-muted mb-1">By <b>{{notification.userName}}</b> at <small class="text-muted">{{notification.createDate | date:'short' }}</small></p>
          </div>
        </div>
      }
    </div>
  }
  @if (!notifications.length) {
    <div class="card-body border-bottom-dashed">
      <div class="earning-data text-center">
        <div class="text-center my-2">
          <p class="text-muted font-15 mb-4">No data found</p>
        </div>
      </div>
    </div>
  }
</div>
